export function getPlanName(planId, allPlans) {
  if (planId !== null) {
    const subscriptionPlan = allPlans?.filter((plan) => plan?.id === planId);
    return subscriptionPlan[0]?.plan_name;
  } else {
    return 'Free';
  }
}
